export const F_CUSTOM_DOMAIN = 'CUSTOM_DOMAINS'
export const F_PWD_PROTECTION = 'PASSWORD_PROTECTION'
export const F_EDIT_MODE = 'EDIT_MODE'
export const F_API_KEY = 'API_KEY'
export const F_EMAIL_GATE = 'EMAIL_GATE'
export const F_FEEDBACK_MODE = 'FEEDBACK_MODE'